"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpenMethod = void 0;
const platform_graphql_api_1 = require("@hotelplan/platform-graphql-api");
function getOpenMethod(entity) {
    if ((entity === null || entity === void 0 ? void 0 : entity.__typename) === 'ExternalLink') {
        switch (entity.openMethod) {
            case platform_graphql_api_1.OpenLinkMethod.NewTab:
            case platform_graphql_api_1.OpenLinkMethod.NewWindow:
                return `_blank`;
            case platform_graphql_api_1.OpenLinkMethod.ThisTab:
                return `_self`;
            case platform_graphql_api_1.OpenLinkMethod.Overlay:
                return platform_graphql_api_1.OpenLinkMethod.Overlay;
            default:
                return;
        }
    }
    return;
}
exports.getOpenMethod = getOpenMethod;
//# sourceMappingURL=getOpenMethod.js.map